import { Typography } from 'antd'
import ProjectLink from 'components/ProjectLink'
import { CIMSPage } from '@cims-online/shared'

const TypeFallback: React.VFC = () => {
  return (
    <Typography.Text>
      No <ProjectLink item={CIMSPage.IssueTypes}>Types</ProjectLink> have been
      configured for this Project
    </Typography.Text>
  )
}

export default TypeFallback
